<template>
  <el-input-number
    class="ainput-number"
    :value="value"
    :precision="precision"
    :controls="controls"
    :min="min"
    :max="max"
    :placeholder="placeholder"
    @change="handleChange"
  >
  </el-input-number>
</template>

<script>
export default {
  components: {},
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: Number,
    precision: {
      type: Number,
      default: 2,
    },
    controls: {
      type: Boolean,
      default: false,
    },
    min: {
      type: Number,
      default: 0.01,
    },
    max: {
      type: Number,
      default: 999999.99,
    },
    placeholder: String,
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    handleChange(val) {
      this.$emit('change', val);
    }
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss">
    .ainput-number .el-input__inner{
        text-align: left;
    }
</style>
